import { ReactNode } from 'react';
import { useEditorContext } from 'app/state/contexts/EditorContext';
import { createPortal } from 'react-dom';

interface PortalProps {
  children: ReactNode;
}

export const Portal = ({ children }: PortalProps) => {
  const { editorContainerRef } = useEditorContext();

  if (!editorContainerRef.current) return null;
  return createPortal(children, editorContainerRef.current);
};
